module.exports = __webpack_public_path__ + "static/depoimento 1-f798edacab8dd3b6bff205baf47b2d8a.svg";